import { render, staticRenderFns } from "./BaixarModeloArquivo.vue?vue&type=template&id=17437b79&scoped=true"
import script from "./BaixarModeloArquivo.vue?vue&type=script&lang=js"
export * from "./BaixarModeloArquivo.vue?vue&type=script&lang=js"
import style0 from "./BaixarModeloArquivo.vue?vue&type=style&index=0&id=17437b79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17437b79",
  null
  
)

export default component.exports